/**
 * Normalize SMTP From into RFC-ish "Display Name" <addr@host> form.
 */
export function composeEmailFrom(displayName: string, email: string): string {
  const addr = (email || '').trim();
  const name = (displayName || '').trim().replace(/"/g, '');
  if (!addr) return name ? `"${name}"` : '';
  if (!name) return addr;
  return `"${name}" <${addr}>`;
}

/** Parse "Name" <email> or Name <email> or bare email. */
export function parseEmailFrom(raw: string): { displayName: string; email: string } {
  const s = (raw || '').trim();
  if (!s) return { displayName: '', email: '' };

  const m =
    s.match(/^"([^"]*)"\s*<([^>]+)>$/) ||
    s.match(/^([^<]*?)\s*<([^>]+)>$/);
  if (m) {
    return { displayName: m[1].trim(), email: m[2].trim() };
  }
  // Bare address
  if (s.includes('@') && !s.includes(' ')) {
    return { displayName: '', email: s };
  }
  // Name only (user typed display name without address) — keep as name
  return { displayName: s, email: '' };
}

export function isValidEmailAddress(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((email || '').trim());
}
